import React, { useState, useRef, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import LogoImage from '../../assets/images-new/logo.svg';
import { APP_DOMAIN, DASHBOARD_LINK } from '../../constants/constants';
import BetaToolTip from './BetaToolTip';
import { pageBounces } from '../../helper';
import WpAPI from '../../WpApi';
const HeaderLogo = (props) => {
    const history = useHistory()
    const popupRef = useRef();
    const [showBetaToolTip, setShowBetaToolTip] = useState(false);
    const onClickOutside = (e) => {
        if (e.target.className != 'header-logo-beta-info icon-info-circle') {
            setShowBetaToolTip(false);
        }
    }
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                onClickOutside && onClickOutside(event);
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [onClickOutside]);
    return (
        <>
            <div className="header-logo-wrapper">
                {(window.location.pathname != '/' && WpAPI.isLoggedIn()) ? <Link
                    className="header-logo"
                    to={DASHBOARD_LINK}
                    onClick={(e) => {
                        gaTrack('RT App', 'Header', 'Top Logo')
                        ga4Track('app_header_rt_logo', 'RT App', 'Top Logo');
                        pageBounces();
                        props?.clickAction && (e.preventDefault() || props.clickAction(e))
                    }}>
                    <LogoImage />
                </Link> : <LogoImage />}

                {/* <div className="beta-label">
                <span className="header-logo-beta">Beta</span>
                <i className="header-logo-beta-info icon-info-circle" onMouseOver={() => {
                    setShowBetaToolTip(true);
                }}></i>
                    {showBetaToolTip ? <div ref={popupRef}><BetaToolTip setShowBetaToolTip={(showBetaToolTip) => { setShowBetaToolTip(showBetaToolTip) }} /></div> : ''}
            </div> */}

            </div>

        </>
    );
}

export default HeaderLogo;